import { createApp } from 'vue';
import { createPinia } from 'pinia';
import axios from 'axios';
import { i18n } from '@/lang';
import router from '@/routes';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

import App from './App.vue';
import './assets/scss/application.scss';
import utils from '@/components/utils';
import { ForgerockPlugin } from '@/components/forgerock';
import BootstrapAlerts from '@/components/ui/BootstrapAlerts.vue';
import StihlOverlay from '@/components/ui/StihlOverlay.vue';

declare global {
  interface Window {
    APP_CONFIG: any;         // app config loaded externally todo define type
    sessionChecked: boolean; // true if the session was checked for validity
  }
}

axios.defaults.timeout = window.APP_CONFIG.axios.defaults.timout;

const store = createPinia();

createApp(App)
  .use(i18n)
  .use(router)
  .use(store)
  // https://www.npmjs.com/package/vue-toast-notification
  .use(VueToast, { position: 'bottom-left', duration: 5000 })
  .use(utils)
  .use(ForgerockPlugin)
  .component('BootstrapAlerts', BootstrapAlerts)
  .component('StihlOverlay', StihlOverlay)
  .mount('#app');
